import { render, staticRenderFns } from "./videoPlayerPage.vue?vue&type=template&id=147cf57c&scoped=true&"
import script from "./videoPlayerPage.vue?vue&type=script&lang=js&"
export * from "./videoPlayerPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "147cf57c",
  null
  
)

export default component.exports